"use strict";
exports.__esModule = true;
exports.EMBED_CONFIRM_SMS_TEXT = void 0;
exports.EMBED_CONFIRM_SMS_TEXT = {
    BODY1: 'By providing your phone number, you consent to receive a one-time text message from Flex and agree to Flex’s ',
    BODY2: ' and ',
    BODY3: '. Standard message and data rates apply',
    NOTICE: 'Privacy Notice',
    POLICY: 'Policy'
};
